import {
  GET_LIST_TICKET,
  GET_LIST_TICKET_SUCCESS,
  GET_LIST_TICKET_FAILURE,
  UPDATE_SEARCHTDATA_TICKET,
} from "./actionTypes";

export const getListTicket = (dataSearch) => ({
  type: GET_LIST_TICKET,
  dataSearch,
});
export const getListTicketSuccess = (data) => ({
  type: GET_LIST_TICKET_SUCCESS,
  payload: data,
});
export const getListTicketFailure = (dataSearch) => ({
  type: GET_LIST_TICKET_FAILURE,
});
export const updateDataSearch = (data) => ({
  type: UPDATE_SEARCHTDATA_TICKET,
  payload: data,
});
